import {
  addDecimals,
  compareDecimalStrings,
  isDecimalString,
  subtractDecimals,
} from "@/shared/utils/decimal";

import type { PayoutBatchCounters, ProviderBalanceView } from "../types/payoutBatches.types";

export type BalanceVerdict = "sufficient" | "insufficient" | "unknown";

/** Source-currency debit of a set of priced rows. Rows without a price contribute nothing. */
export function sumDebit(rows: ReadonlyArray<{ pricing: { total_debit_source: string } | null }>): string {
  return rows.reduce(
    (total, row) => (row.pricing ? addDecimals(total, row.pricing.total_debit_source) : total),
    "0",
  );
}

export function remainingAfter(available: string, debit: string): string {
  return subtractDecimals(available, debit);
}

export function balanceVerdict(available: string | null | undefined, debit: string): BalanceVerdict {
  if (available == null || !isDecimalString(available) || !isDecimalString(debit)) return "unknown";
  return compareDecimalStrings(available, debit) >= 0 ? "sufficient" : "insufficient";
}

/**
 * Whether the run needs the INTERNAL acknowledgement: the float reading is not fresh and OK, or it does not
 * cover what the beneficiaries receive (gross, in the delivery currency).
 */
export function isProviderBalanceAtRisk(balance: ProviderBalanceView | null, receiveGross: string): boolean {
  if (!balance) return false;
  if (balance.status !== "OK" || balance.available == null) return true;
  return balanceVerdict(balance.available, receiveGross) !== "sufficient";
}

export function selectedShare(counters: Pick<PayoutBatchCounters, "selected" | "total">): number {
  return counters.total === 0 ? 0 : Math.round((counters.selected / counters.total) * 100);
}
